import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { catchError, map, tap } from "rxjs/operators";
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpParams
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { DatePipe } from "@angular/common";

import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";
import "rxjs/add/operator/do";
import "rxjs/add/observable/of";
import { of } from "rxjs/observable/of";
import { UserService } from "./user.service";
import { environment } from "../../environments/environment";
import 'parse';
const parse: typeof Parse = require('parse');
import { ParseService } from "./parse.service";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json"
  }),
  params: new HttpParams()
};

@Injectable()
export class ContactService {
  private sendMailBaseUrl =
    environment.baseURL + ":" + environment.portAPI + "/api/mail";

  constructor(
    private _http: HttpClient,
    private _userService: UserService,
    private parseSvc: ParseService
  ) { }

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a TchekOldService message with the MessageService */
  private log(message: string) { }

  sendMailOld(subject, msg, name): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + this._userService.getUserToken()
      }),
      params: new HttpParams()
    };
    httpOptions.params = httpOptions.params
      .set("subject", subject)
      .set("name", name)
      .set("msg", msg);
    return this._http.get<any>(this.sendMailBaseUrl, httpOptions).pipe(
      tap(response => {
        this.log(`test ok`);
      }),
      catchError(this.handleError("test", []))
    );
  }

  public sendMail(
    subject: string,
    message: string,
    firstName: string, company: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      parse.Cloud.run("sendMail", {
        subject: subject,
        name: firstName,
        msg: message,
        company: company
      }).then(
        res => {
          resolve(res);
        },
        error => {
          reject(error);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/service/contact.service.ts